module.exports = __webpack_public_path__ + "files/ce7564a5b799df1becd691a4c277c8c6.png";